import { validateWorkPhone } from '../validateWorkPhone'

export const formValidatorForWorkPhone = (_: any, value: string) => {
  if (validateWorkPhone(value)) {
    return Promise.resolve()
  }
  return Promise.reject(new Error('Phone number is not in a valid format.'))
}
